export default __webpack_public_path__ + "static/media/RUNE.2c342810.png";